const initialState = {
  studentId: '',
  studentName: null,
  subject: null,
  subjectName: null,
  date: '',
  overrideLimits: false,
};

export default initialState;
